import {connect} from 'react-redux';
import {RouteComponentProps} from 'react-router';
import {Dispatch} from 'redux';

import GeneratorEntity from '../../../models/Generator';
import {loadRemainingGeneratorDetails, saveEditChanges} from '../../../store/actions';
import {IState} from '../../../store/reducer';
import { loadGeneratorsStart, loadGeneratorsSuccess, switchEditView } from './../../../store/actions/index';
import { loadGenerators } from './../../../utils/api';
import EditGeneratorComponent from './EditGeneratorComponent';

type RouteProps = RouteComponentProps < {id: string} >;

// TODO: check which generator should be edited by ID
// push that editor, and only that editor to the components (use get editor by id from form component and use here)
// have a onCHange method that saves on edit and sets dirty flag
/* tslint:disable */
const template: GeneratorEntity =  {
  categories: ['NSC', 'Simple', 'Religion'],
  explanation: 'A Generator to return Adam or Eve',
  id: 'new',
  name: 'NSC Generator (new)',
  path: 'Examples/NSC Generator',
  resultPattern: '|| Name: || {name} \r\n',
  tables: [
    {
      "name": "name",
      "entries": [
				{
					"m": 1,
					"v": "Adam"
				},
				{
					"m": 1,
					"v": "Eve"
				}
			]
    },
  ]
}
/* tslint:enable */

const getGeneratorByID = (id: string, generators: GeneratorEntity[]) => {
  let foundGen = new GeneratorEntity()
  if (id === 'new'){
    foundGen = template
  } else {
    const find = generators.find(gen => gen.id === id)
    if (find !== undefined) {
        foundGen = find;
    }

    const sec = generators.find(gen => gen.id === id)
    if (sec !== undefined) {
        foundGen = sec;
    }
  }
  return foundGen
}


export const reloadGenerators = (dispatch: Dispatch, callback?: any) => {
  dispatch(loadGeneratorsStart())
  loadGenerators().then( (genResult) => {
    dispatch(loadGeneratorsSuccess(genResult))
    if (callback) {
      callback()
    }
  })
}

const mapStateToProps = (state : IState, routeProps : RouteProps) => {
  return {
    generator: getGeneratorByID(routeProps.match.params.id, state.gen.generators),
    generators: state.gen.generators,
    id: routeProps.match.params.id,
    preferredEditor:  state.user.profile.preferredEditor,
    profile: state.user.profile,
    theme: state.user.profile.editorTheme,
  }
}

const mapDispatchToProps = (dispatch : Dispatch) => {
  return {
    loadGeneratorDetails: (id : string, callback: any) => loadRemainingGeneratorDetails(dispatch, id),
    refreshGens: (callback?: any) => reloadGenerators(dispatch, callback),
    switchEditView: (view: string) => switchEditView(dispatch, view),
    updateGenerator: (generator: GeneratorEntity) => saveEditChanges(dispatch, generator),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditGeneratorComponent)



// WEBPACK FOOTER //
// ./src/Containers/generators/EditGenerator/index.tsx